import { render, staticRenderFns } from "./EventDateGridComponent.vue?vue&type=template&id=5b79cd4e"
import script from "./EventDateGridComponent.vue?vue&type=script&lang=js"
export * from "./EventDateGridComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports